import $ from 'jquery';

$(function () {
	$(document).on('click', '#procedure-recommendations .procedure-document .btn-show-all', function () {
		$(this).parents('.procedure-document').find('.header-hide').removeClass('header-hide');
		$(this).remove();

		return false;
	});

	$('#procedure-recommendations .procedure-document .btn-show-all').each(function () {
		if ($(this).parents('.procedure-document').find('.header-hide').length === 0) {
			$(this).remove();
		}
	});
});
